import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';

/**
 * Mise à jour MANUELLE et NON bloquante de la PWA.
 *
 * On n'affiche le bouton « Mettre l'app à jour » que lorsqu'un service worker
 * est RÉELLEMENT en attente (`registration.waiting`) — pas sur un simple signal
 * de détection, qui peut rester vrai alors que le worker est déjà actif (rien à
 * appliquer → le clic ne fait rien → l'app se fige). C'est un bouton flottant,
 * jamais une modale : il ne peut pas geler l'écran. Au clic on active le worker
 * en attente (SKIP_WAITING) puis on recharge. On ne recharge jamais tout seul :
 * un rechargement en pleine prise de photo casse l'autorisation caméra iOS.
 */
const Updater = (): JSX.Element => {
  const [waiting, setWaiting] = useState<ServiceWorker | null>(null);

  useEffect(() => {
    const check = (): void => {
      navigator.serviceWorker
        ?.getRegistration()
        .then((registration) => {
          if (!registration) {
            return;
          }
          registration.update().catch(() => undefined);
          setWaiting(registration.waiting);
        })
        .catch(() => undefined);
    };
    check();
    const intervalId = window.setInterval(check, 60 * 1000);
    const onVisible = (): void => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  if (!waiting) {
    return <></>;
  }

  const apply = (): void => {
    navigator.serviceWorker.addEventListener(
      'controllerchange',
      () => window.location.reload(),
      { once: true }
    );
    waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <div
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <Button
        color="primary"
        onClick={apply}
        style={{
          pointerEvents: 'auto',
          borderRadius: 999,
          boxShadow: '0 6px 20px rgba(0,0,0,0.3)',
        }}
      >
        Mettre l&rsquo;app à jour
      </Button>
    </div>
  );
};

export default Updater;
